/* GetInLight: sticky product nav, compare page, cart drawer helpers. No dependencies. */
(function () {
  'use strict';
  if (window.__gilCommerce) return;
  window.__gilCommerce = true;

  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: cur });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- sticky product nav ---------- */
  function initPnav() {
    var nav = document.querySelector('[data-gil-pnav]');
    if (!nav || nav.__gilInit) return;
    nav.__gilInit = true;
    if (nav.classList.contains('gil-pnav--static')) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-gil-target]'));
    var addBtn = nav.querySelector('[data-gil-pnav-add]');
    var priceEl = nav.querySelector('[data-gil-pnav-price]');
    var variantEl = nav.querySelector('[data-gil-pnav-variant]');
    var imgEl = nav.querySelector('.gil-pnav__img img');

    function mainAdd() {
      var list = document.querySelectorAll('product-info button[name="add"], product-info [type="submit"][name="add"]');
      for (var i = 0; i < list.length; i++) if (!list[i].closest('product-sticky-form')) return list[i];
      return null;
    }
    function targetEl(sel) { try { return document.querySelector(sel); } catch (e) { return null; } }
    function navH() { return nav.getBoundingClientRect().height || 68; }

    links.forEach(function (a) { if (!targetEl(a.getAttribute('data-gil-target'))) a.hidden = true; });
    links = links.filter(function (a) { return !a.hidden; });

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var el = targetEl(a.getAttribute('data-gil-target'));
        if (!el) return;
        e.preventDefault();
        var top = el.getBoundingClientRect().top + window.pageYOffset - navH() - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    if (addBtn) addBtn.addEventListener('click', function () {
      var b = mainAdd();
      if (b && !b.disabled) b.click();
    });

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (priceEl && typeof v.price === 'number') priceEl.textContent = money(v.price);
      if (variantEl && v.title) variantEl.textContent = v.title;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      var src = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
      if (!src && v.featured_image && v.featured_image.src) src = v.featured_image.src;
      if (imgEl && src) { imgEl.removeAttribute('srcset'); imgEl.src = src; }
    }, true);

    var ticking = false;
    function update() {
      ticking = false;
      var b = mainAdd();
      var show = false;
      if (b) { var r = b.getBoundingClientRect(); show = r.bottom < 0; }
      nav.classList.toggle('is-on', show);
      nav.setAttribute('aria-hidden', show ? 'false' : 'true');
      links.forEach(function (a) { a.tabIndex = show ? 0 : -1; });
      if (addBtn) addBtn.tabIndex = show ? 0 : -1;
      if (!show) return;
      var line = navH() + 24, current = null;
      links.forEach(function (a) {
        var el = targetEl(a.getAttribute('data-gil-target'));
        if (el && el.getBoundingClientRect().top <= line) current = a;
      });
      links.forEach(function (a) { a.classList.toggle('is-active', a === current); });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- compare page ---------- */
  function initCompare() {
    document.querySelectorAll('[data-gil-compare]').forEach(function (root) {
      if (root.__gilInit) return;
      root.__gilInit = true;
      var max = parseInt(root.getAttribute('data-max'), 10) || 4;
      var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-gil-col]'));
      var diff = root.querySelector('[data-gil-diff]');
      var hint = root.querySelector('[data-gil-hint]');
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-gil-row]'));

      function apply() {
        var on = boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.getAttribute('data-gil-col'); });
        root.querySelectorAll('[data-gil-c]').forEach(function (c) { c.hidden = on.indexOf(c.getAttribute('data-gil-c')) === -1; });
        rows.forEach(function (row) {
          var vals = [];
          row.querySelectorAll('td[data-gil-c]').forEach(function (td) { if (!td.hidden) vals.push(td.textContent.replace(/\s+/g, ' ').trim()); });
          var same = vals.length > 1 && vals.every(function (v) { return v === vals[0]; });
          row.hidden = !!(diff && diff.checked && same);
        });
      }
      boxes.forEach(function (b) {
        b.addEventListener('change', function () {
          var n = boxes.filter(function (x) { return x.checked; }).length;
          if (b.checked && n > max) { b.checked = false; if (hint) hint.hidden = false; return; }
          if (!b.checked && n < 2) { b.checked = true; return; }
          if (hint) hint.hidden = true;
          apply();
        });
      });
      if (diff) diff.addEventListener('change', apply);
      boxes.filter(function (b) { return b.checked; }).slice(max).forEach(function (b) { b.checked = false; });
      apply();
    });
  }

  /* ---------- cart drawer: Continue shopping closes the drawer ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-gil-continue]');
    if (!t) return;
    e.preventDefault();
    var close = document.querySelector('#CartDrawer .drawer__close');
    if (close) close.click();
  });

  /* ---------- cart drawer: trust lines under the checkout buttons ---------- */
  function injectDrawer() {
    var tpl = document.getElementById('gil-drawer-extras-tpl');
    var drawer = document.getElementById('CartDrawer');
    if (!tpl || !drawer) return;
    var form = drawer.querySelector('.drawer__footer-buttons');
    if (!form || !form.parentNode) return;
    if (form.parentNode.querySelector('.gil-drawer-extras')) return;
    form.parentNode.appendChild(tpl.content.cloneNode(true));
  }
  function watchDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.__gilWatch) return;
    drawer.__gilWatch = true;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(injectDrawer, 30); }).observe(drawer, { childList: true, subtree: true });
    injectDrawer();
  }

  /* ---------- FAQ: one open at a time ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var list = d.closest('[data-gil-faq]');
    if (!list) return;
    list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  function init() { initPnav(); initCompare(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
